import css from "./ButtonGroup.module.scss";

type Props = {
  children: React.ReactNode;
};

export function ButtonGroup({ children }: Props) {
  return <div className={css.group}>{children}</div>;
}
